import {classNames as $6e6392558d48dfec$export$ce4ab0c55987d1ff} from "../utils/classNames.mjs";
import {MenuContext as $9f4d05c8f96993f7$export$c7e742effb1c51e2, SubmenuTriggerContext as $9f4d05c8f96993f7$export$8d97fe02339fc0e3, useMenuStateContext as $9f4d05c8f96993f7$export$efa3856fc0e85e7f} from "./context.mjs";
import {Popover as $3a473e3b7032f626$export$5b6b19405a83ff9d} from "../overlays/Popover.mjs";
import "../menu_vars.css";
import $di7IS$menu_vars_cssmjs from "../menu_vars_css.mjs";
import {useIsMobileDevice as $f357d4aae54bf1ff$export$736bf165441b18c7} from "../utils/useIsMobileDevice.mjs";
import {isFocusWithin as $di7IS$isFocusWithin} from "react-aria/private/utils/shadowdom/DOMFunctions";
import {mergeProps as $di7IS$mergeProps} from "react-aria/mergeProps";
import $di7IS$react, {useRef as $di7IS$useRef} from "react";
import $di7IS$reactdom from "react-dom";
import {useLocale as $di7IS$useLocale} from "react-aria/I18nProvider";
import {useSubmenuTrigger as $di7IS$useSubmenuTrigger} from "react-aria/useMenu";
import {useSubmenuTriggerState as $di7IS$useSubmenuTriggerState} from "react-stately/useMenuTriggerState";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 











function $c7fb8c3de17f5e37$var$SubmenuTrigger(props) {
    let triggerRef = (0, $di7IS$useRef)(null);
    let { children: children, targetKey: targetKey } = props;
    let [menuTrigger, menu] = (0, $di7IS$react).Children.toArray(children);
    let { popoverContainer: popoverContainer, trayContainerRef: trayContainerRef, menu: parentMenuRef, submenu: menuRef, rootMenuTriggerState: rootMenuTriggerState } = (0, $9f4d05c8f96993f7$export$efa3856fc0e85e7f)();
    let submenuTriggerState = (0, $di7IS$useSubmenuTriggerState)({
        triggerKey: targetKey
    }, rootMenuTriggerState);
    let { submenuTriggerProps: submenuTriggerProps, submenuProps: submenuProps, popoverProps: popoverProps } = (0, $di7IS$useSubmenuTrigger)({
        parentMenuRef: parentMenuRef,
        submenuRef: menuRef
    }, submenuTriggerState, triggerRef);
    let isMobile = (0, $f357d4aae54bf1ff$export$736bf165441b18c7)();
    let onBackButtonPress = ()=>{
        submenuTriggerState.close();
        if (parentMenuRef.current && !(0, $di7IS$isFocusWithin)(parentMenuRef.current)) parentMenuRef.current.focus();
    };
    let { direction: direction } = (0, $di7IS$useLocale)();
    let mobileSubmenuKeyDown = (e)=>{
        switch(e.key){
            case 'ArrowLeft':
                if (direction === 'ltr') triggerRef.current?.focus();
                break;
            case 'ArrowRight':
                if (direction === 'rtl') triggerRef.current?.focus();
                break;
        }
    };
    let overlay;
    if (isMobile) {
        delete submenuTriggerProps.onBlur;
        delete submenuTriggerProps.onHoverChange;
        submenuProps.autoFocus ??= true;
        if (trayContainerRef.current && submenuTriggerState.isOpen) overlay = /*#__PURE__*/ (0, $di7IS$reactdom).createPortal(menu, trayContainerRef.current);
    } else {
        let onDismissButtonPress = ()=>{
            submenuTriggerState.close();
            parentMenuRef.current?.focus();
        };
        overlay = /*#__PURE__*/ (0, $di7IS$react).createElement((0, $3a473e3b7032f626$export$5b6b19405a83ff9d), {
            ...popoverProps,
            onDismissButtonPress: onDismissButtonPress,
            UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($di7IS$menu_vars_cssmjs))), 'spectrum-Submenu-popover'),
            container: popoverContainer,
            containerPadding: 0,
            enableBothDismissButtons: true,
            UNSAFE_style: {
                clipPath: 'unset',
                overflow: 'visible',
                borderWidth: '0px'
            },
            state: submenuTriggerState,
            triggerRef: triggerRef,
            scrollRef: menuRef,
            placement: "end top",
            hideArrow: true
        }, menu);
    }
    let menuContext = {
        ...(0, $di7IS$mergeProps)(submenuProps, {
            ref: menuRef,
            UNSAFE_style: isMobile ? {
                width: '100%',
                maxHeight: 'inherit'
            } : undefined,
            UNSAFE_className: (0, $6e6392558d48dfec$export$ce4ab0c55987d1ff)((0, ($parcel$interopDefault($di7IS$menu_vars_cssmjs))), {
                'spectrum-Menu-popover': !isMobile
            }),
            ...isMobile && {
                onBackButtonPress: onBackButtonPress,
                onKeyDown: mobileSubmenuKeyDown
            }
        })
    };
    return /*#__PURE__*/ (0, $di7IS$react).createElement((0, $di7IS$react).Fragment, null, /*#__PURE__*/ (0, $di7IS$react).createElement((0, $9f4d05c8f96993f7$export$8d97fe02339fc0e3).Provider, {
        value: {
            triggerRef: triggerRef,
            ...submenuTriggerProps
        }
    }, menuTrigger), /*#__PURE__*/ (0, $di7IS$react).createElement((0, $9f4d05c8f96993f7$export$c7e742effb1c51e2).Provider, {
        value: menuContext
    }, overlay));
}
$c7fb8c3de17f5e37$var$SubmenuTrigger.getCollectionNode = function*(props) {
    let childArray = [];
    (0, $di7IS$react).Children.forEach(props.children, (child)=>{
        if (/*#__PURE__*/ (0, $di7IS$react).isValidElement(child)) childArray.push(child);
    });
    let [trigger] = childArray;
    let [, content] = props.children;
    yield {
        element: /*#__PURE__*/ (0, $di7IS$react).cloneElement(trigger, {
            ...trigger.props,
            hasChildItems: true,
            isTrigger: true
        }),
        wrapper: (element)=>/*#__PURE__*/ (0, $di7IS$react).createElement($c7fb8c3de17f5e37$var$SubmenuTrigger, {
                key: element.key,
                targetKey: element.key,
                ...props
            }, element, content)
    };
};
let $c7fb8c3de17f5e37$export$ecabc99eeffab7ca = $c7fb8c3de17f5e37$var$SubmenuTrigger;


export {$c7fb8c3de17f5e37$export$ecabc99eeffab7ca as SubmenuTrigger};
//# sourceMappingURL=SubmenuTrigger.mjs.map
